import type { OgCityKey } from "@/lib/ogImages";

export const PARKER_PROFILE: {
  city: string;
  citySlug: OgCityKey;
  cityGeo: { lat: number; lng: number };
  zips: string[];
  neighborhoods: string[];
  nearbyCities: string[];
} = {
  city: "Parker",
  citySlug: "parker",
  cityGeo: { lat: 39.5186, lng: -104.7614 },
  zips: ["80134", "80138"],
  neighborhoods: [
    "Stonegate", "Stroh Ranch", "The Pinery",
    "Canterberry Crossing", "Idyllwilde", "Reata North",
    "Trails at Crowfoot", "Cottonwood",
  ],
  nearbyCities: ["Castle Rock", "Lone Tree", "Elizabeth", "Franktown"],
};
